import { useEffect, useContext } from "react";
import { DynamicContext } from "./DynamicContext";
import { get } from "../helper/Api_helper";
import {
  VYLABS_BASE_URL,
  GET_SUBSCRIPTION_DETAILS,
} from "../helper/url_helper";

const SubscriptionFetcher = () => {
  const {
    setSubscriptionDetails,
    userDetails,
    setHasSubscription,
    setIsSubscriptionLoading,
    setIsInitialSubscriptionFetchDone,
    subscriptionRefetchKey,
  } = useContext(DynamicContext);

  useEffect(() => {
    let cancelled = false;

    const fetchSubscriptionDetails = async () => {
      setIsInitialSubscriptionFetchDone(false);
      setIsSubscriptionLoading(true);

      const token = localStorage.getItem("token");
      if (!token) {
        setSubscriptionDetails(null);
        setHasSubscription(false);
        setIsSubscriptionLoading(false);
        setIsInitialSubscriptionFetchDone(true);
        return;
      }

      try {
        const response = await get(VYLABS_BASE_URL, GET_SUBSCRIPTION_DETAILS);
        if (cancelled) return;
        const isValid =
          response &&
          (response.status === "active" || response.status === "trialing");
        setSubscriptionDetails(response);
        setHasSubscription(!!isValid);
      } catch (error) {
        if (cancelled) return;
        console.error("Failed to fetch subscription details:", error);
        setSubscriptionDetails(null);
        setHasSubscription(false);
      } finally {
        if (!cancelled) {
          setIsSubscriptionLoading(false);
          setIsInitialSubscriptionFetchDone(true);
        }
      }
    };

    fetchSubscriptionDetails();
    return () => {
      cancelled = true;
    };
  }, [
    userDetails?.id,
    userDetails?.tenant_id,
    subscriptionRefetchKey,
    setSubscriptionDetails,
    setHasSubscription,
    setIsSubscriptionLoading,
    setIsInitialSubscriptionFetchDone,
  ]);

  return null;
};

export default SubscriptionFetcher;
